import {
    AutocompleteInput,
    Create,
    DateInput,
    ReferenceInput,
    SelectInput, SimpleForm,
    useNotify,
    useRedirect,
    useRefresh
} from "react-admin";

const FormsRequestCreate = (props) => {

    const redirect = useRedirect()
    const notify = useNotify()
    const refresh = useRefresh()

    const onSuccess = ({ data }) => {
        notify('Fomulário criado com sucesso')
        redirect('/formsAvailability', undefined, {}, {}, { data })
        refresh()
    }

    return (
        <Create {...props} onSuccess={onSuccess}>
            <SimpleForm >
                <ReferenceInput
                    perPage={100000}
                    label="Formulário"
                    source="formId"
                    reference="forms"
                    sort={{}}
                    fullWidth
                    required
                >
                    <AutocompleteInput
                        optionText="name"
                        optionValue="id"
                    />
                </ReferenceInput>
                <ReferenceInput
                    sort={{ field: "name", order: "ASC" }}
                    perPage={10000}
                    filter={{ academic_period: 'current' }}
                    label="Turma"
                    source="classId"
                    reference="classes"
                    fullWidth
                    required
                >
                    <SelectInput optionText={'name'} optionValue={'id'} />
                </ReferenceInput>
                <DateInput source="start" label={'Inicio Disponibilidade'} fullWidth required />
                <DateInput source="end" label={'Fim Disponibilidade'} fullWidth required />
            </SimpleForm>
        </Create >
    )
}

export default FormsRequestCreate;